

export const step1 = {
    en: {
        step1Headline: "🔐 Welcome to SecurePath!",
        step1Description: `
Smartphone security is vast and complex topic - but we've **simplified everything** for you. Here's how it works:

1️⃣ **Pick Your Protection Profile**
We'll guide you through **45+ risk areas** with simple, transparent steps. Expert? Dive deeper anytime!

2️⃣ **Follow Bite-Sized Lessons**
Lock down risks at your own pace. Leave and return anytime - track progress on your **📊 Dashboard** (menu).

💡 **Need Help?**
- **Humans Got You Covered** 👋 Can't find something? Message us! Your feedback shapes the platform.
- **Stay Curious!** 🔍 This isn't just an app - it's your **ally against hidden threats**. Explore sources and learn at your own pace!`,
    },
    es: {
        step1Headline: "🔐 ¡Bienvenido a Tu Viaje de Privacidad!",
        step1Description: `
La seguridad de tu smartphone es amplia y compleja - pero lo hemos **simplificado todo** para ti. Así funciona:

1️⃣ **Elige Tu Perfil de Protección**
Te guiaremos por **45+ áreas de riesgo** con pasos simples y transparentes. ¿Eres experto? Profundiza cuando quieras.

2️⃣ **Sigue Lecciones en Porciones Pequeñas**
Bloquea riesgos a tu ritmo. Sal y regresa cuando quieras - sigue tu progreso en el **📊 Tablero** (menú).

💡 **¿Necesitas Ayuda?**
- **Humanos Te Apoyan** 👋 ¿No encuentras algo? ¡Escríbenos! Tus comentarios moldean la plataforma.
- **¡Sé Curioso!** 🔍 Esto no es solo una app - es tu **aliado contra amenazas ocultas**. Explora fuentes y aprende a tu ritmo!`,
    },
    pt: {
        step1Headline: "🔐 Bem-vindo à Sua Jornada de Privacidade!",
        step1Description: `Segurança de smartphones é um assunto vasto e complexo - mas **simplificamos tudo** para você. Funciona assim:

1️⃣ **Escolha Seu Perfil de Proteção**
Guiaremos você por **45+ áreas de risco** com passos simples e transparentes. É experto? Aprofunde quando quiser.

2️⃣ **Siga Lições em Etapas Curta**
Bloqueie riscos no seu ritmo. Saia e retorne quando quiser - acompanhe seu progresso no **📊 Painel**.

💡 **Precisa de Ajuda?**
- **Humanos te ajudam** 👋 Não encontrou algo? Nos avise! Seu feedback nos ajuda a melhorar a plataforma.
- **Seja Curioso!** 🔍 Isto não é só um app - é seu **aliado contra ameaças ocultas**. Explore nossas fontes e aprenda no seu ritmo!`,
    }
};

export const step2 = {
    en: {
        step2Headline: 'Which device are we securing?'
    },
    pt: {
        step2Headline: 'Qual dispositivo estamos protegendo?'
    },
    es: {
        step2Headline: '¿Qué dispositivo estamos protegiendo?'
    }
}

export const step3 = {
    en: {
        step3Headline: 'Choose your security profile'
    },
    pt: {
        step3Headline: 'Escolha seu perfil de segurança'
    },
    es: {
        step3Headline: 'Elige tu perfil de seguridad'
    }
}

export const step4 = {
    en: {
        step4Headline: 'Choose your pace',
        paceTitle: 'Pace',
        selectPace: 'Select your pace',
        paceFullTitle: 'Full lessons',
        paceFullDescription: 'The complete story for each topic: why it matters, the threats to know, then the action steps.',
        paceQuickTitle: 'Quick steps',
        paceQuickDescription: 'Skip the background and jump straight to the action checklist in each lesson.',
        paceChangeNote: 'You can change your pace anytime in your preferences.'
    },
    pt: {
        step4Headline: 'Escolha seu ritmo',
        paceTitle: 'Ritmo',
        selectPace: 'Selecione seu ritmo',
        paceFullTitle: 'Lições completas',
        paceFullDescription: 'A história completa de cada tema: por que importa, as ameaças a conhecer e depois os passos de ação.',
        paceQuickTitle: 'Passos rápidos',
        paceQuickDescription: 'Pule o contexto e vá direto para a lista de ações de cada lição.',
        paceChangeNote: 'Você pode mudar seu ritmo a qualquer momento nas suas preferências.'
    },
    es: {
        step4Headline: 'Elige tu ritmo',
        paceTitle: 'Ritmo',
        selectPace: 'Selecciona tu ritmo',
        paceFullTitle: 'Lecciones completas',
        paceFullDescription: 'La historia completa de cada tema: por qué importa, las amenazas a conocer y luego los pasos de acción.',
        paceQuickTitle: 'Pasos rápidos',
        paceQuickDescription: 'Sáltate el contexto y ve directo a la lista de acciones de cada lección.',
        paceChangeNote: 'Puedes cambiar tu ritmo en cualquier momento en tus preferencias.'
    }
};

export const step5 = {
    en: {
        step5Headline: 'Review'
    },
    pt: {
        step5Headline: 'Revisão'
    },
    es: {
        step5Headline: 'Revisión'
    }
};
